import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { formatCell } from "src/app/utils/common";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import {
  DeleteDpParams,
  SetDpParams,
} from "src/app/store/actions/global-subheader.actions";
import {
  faRegistered,
  faSortUp,
  faSortDown,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import { faRegistered as faRegisteredLight } from "@fortawesome/pro-light-svg-icons";
import { DatePipe } from "@angular/common";
import { VAIconRegistryService, republish } from "@va/core-library/icons";
import dayjs from "dayjs";
import { MatTable } from "@angular/material/table";
@Component({
  selector: "app-drug-distribution-analysis-grid",
  templateUrl: "./drug-distribution-analysis-grid.component.html",
  styleUrls: ["./drug-distribution-analysis-grid.component.scss"],
})
export class DrugDistributionAnalysisGridComponent implements OnInit {
  @Input() serviceFunction: string;
  @Input() tableName: string;
  @Input() inReverseOrder = false;
  @Input() dataSettings;
  @Input() drugResearchParameters: any[] = [];
  @Input() dataCall;
  @Input() reaffirmCall;
  @Output() onDataSourceChanged: EventEmitter<number> = new EventEmitter();
  @Input() brokerHighLowEnable;
  @Input() periodList = [];
  @ViewChild(MatTable) table: MatTable<any>;
  @Input() drug_dapparameterid;
  @Input() showPOS;
  @Output() onResearchIconClick: EventEmitter<any> = new EventEmitter();
  @Output() showResearchParameterOnGrid: EventEmitter<any> = new EventEmitter();

  faRegistered = faRegistered;
  faRegisterdLight = faRegisteredLight;
  routeSubscriber: Subscription;
  dpCallSubscriber: Subscription;
  cTagId = 0;
  companyId = 0;
  dataObservable: Observable<any>;
  dataSource = [];
  dataSourceDefaultOrder: any = [];
  displayColumns = ["name", "date_published"];
  forecastPeriodData = {};
  consolidatedDP = 0;
  datePublished;
  reaffirm: boolean;
  apiResponce: any;
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  book = faBook;
  sortDirection = "";
  activeSort = "";

  customSkeletonConfig = {
    skeletonType: "grid",
    config: {
      grid: {
        count: {
          row: 4,
          column: 5,
        },
        bordered: true,
      },
    },
  };
  keyColumnMapping = {
    standarddeviation: "Standard Deviation",
    consensusexminexmax: "Consensus Ex Max, Ex Min",
    consensusexmax: "Consensus Ex Max",
    consensusexmin: "Consensus Ex Min",
    secondquartile: "Second Quartile",
    totalbrokercount: "brokers",
    mean: "Mean",
    range: "Range",
    cv: "Coefficient of Variation (%)",
    thirdquartile: "Third Quartile",
    firstquartile: "First Quartile",
    brokercount: "Number of Analysts",
    max: "High",
    min: "Low",
  };
  showSortedIds = false;
  selectedCell: string;
  selectedRow: any;
  selectedKeys: any;
  firstColumnConfig: {
    name: "";
    span: 2;
  };
  constructor(
    private dataService: PharmaDataService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([republish]);
  }
  ngOnInit() {
    if (this.tableName === "Broker") {
      this.sortDirection = "desc";
      this.activeSort = "date_published";
    }
    this.route.params.subscribe((param) => {
      if (param.cTagId) {
        this.cTagId = Number(param.cTagId);
      }
    });
  }

  makeDataCall() {
    if (!this.dataSettings) {
      console.error("Data Settings is not present.");
      return;
    }
    this.selectedCell = "";
    this.selectedRow = 0;
    this.store.dispatch(new DeleteDpParams());

    this.periodList = [...this.dataSettings.periodData.period];
    if (this.tableName === "Consensus") {
      //CHANGES
      //Table columns, main data's keys, key-column name map
      this.displayColumns = ["name", "unit"].concat(this.periodList);
      this.selectedKeys = [
        "13001",
        "brokercount",
        "max",
        "secondquartile",
        "min",
      ];
      this.keyColumnMapping.secondquartile = "Median";
    } else if (this.tableName === "Broker") {
      this.showSortedIds = true;
      // this.displayColumns = ["broker", "date_published", "unit"].concat(
      //   this.periodList,
      // );
      // this.selectedKeys = [];
      let tempCols = ["broker", "date_published"];
      if (this.showPOS) {
        tempCols.push("pos");
      }
      tempCols = tempCols.concat(["unit"]).concat(this.periodList);
      this.displayColumns = JSON.parse(JSON.stringify(tempCols));
      this.selectedKeys = [];
    } else if (this.tableName === "Descriptive statistics") {
      this.displayColumns = ["name", "unit"].concat(this.periodList);
      this.selectedKeys = ["standarddeviation", "cv", "range"];
    } else if (this.tableName === "Quartiles") {
      this.displayColumns = ["name", "unit"].concat(this.periodList);
      this.selectedKeys = [
        "min",
        "firstquartile",
        "secondquartile",
        "thirdquartile",
        "max",
      ];
      this.keyColumnMapping.min = "Lowest Value";
      this.keyColumnMapping.max = "Highest Value";
    } else if (this.tableName === "Trimmed Means") {
      this.displayColumns = ["name", "unit"].concat(this.periodList);
      this.selectedKeys = [
        "consensusexmax",
        "consensusexmin",
        "consensusexminexmax",
      ];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes && changes.dataCall && changes.dataCall.currentValue) ||
      (changes && changes.dataSettings && changes.dataSettings.currentValue) ||
      (changes && changes.reaffirmCall && changes.reaffirmCall.currentValue) ||
      (changes && changes.showPOS && changes.showPOS.currentValue !== undefined)
    ) {
      this.makeDataCall();
      this.onDataResolved(this.dataCall);
    }
    if (changes && changes.drugResearchParameters) {
      this.addResearchParameters();
    }
  }

  formatCellValue(metaData, value) {
    // if (metaData.unit === "" && metaData.magnitude === "Abs") {
    //   console.log("value",value)
    //   return value;
    // }

    const newVal = formatCell(
      value,
      "",
      metaData.unit,
      this.tableName === "Descriptive statistics" ||
        this.dataSettings.view_by[0] === "revision"
        ? "values"
        : this.dataSettings.view_by[0],
    );
    return newVal;
  }

  formatRow(row, valKey, keyName) {
    if (!row.period) {
      return row;
    }
    const newRow = { ...row };
    newRow["period"] = {};

    this.periodList.forEach((period) => {
      newRow["period"][`${period}`] = {};
      if (
        row.period[`${period}`] &&
        (row.period[`${period}`][valKey] === null ||
          row.period[`${period}`][valKey] === undefined)
      ) {
        return;
      }
      if (
        row.period[`${period}`] &&
        row.period[`${period}`][valKey] !== undefined
      ) {
        let newVal = row.period[`${period}`][valKey];
        if (keyName !== "brokercount") {
          newVal = this.formatCellValue(
            row.meta,
            row.period[`${period}`][valKey],
          );
        }

        if (
          this.apiResponce.maxsource.period[period] &&
          String(this.apiResponce.maxsource.period[period]["value"]) === keyName
        ) {
          newRow["period"][`${period}`]["high_low_color"] = "#C5FFC5";
        } else if (
          this.apiResponce.minsource.period[period] &&
          String(this.apiResponce.minsource.period[period]["value"]) === keyName
        ) {
          newRow["period"][`${period}`]["high_low_color"] = "#FFD0D0";
        } else {
          newRow["period"][`${period}`]["high_low_color"] = "";
        }
        newRow["period"][`${period}`]["value"] = newVal;
        newRow["period"][`${period}`]["raw"] = row.period[`${period}`][valKey];
      }
    });
    return newRow;
  }

  loadFormulaBar(dataPointObj, period, isPOS = false) {
    if (period === "" && isPOS) {
      period = dataPointObj["meta"]["pos_period"];
    }
    this.selectedCell = "";
    this.selectedRow = 0;
    //this.store.dispatch(new DeleteDpParams());
    let dpParams = {};
    const blockFormulaBar = [
      "Number of Analysts",
      "Median",
      "Standard Deviation",
      "Coefficient of Variation (%)",
      "Range",
      "Lowest Value",
      "First Quartile",
      "Second Quartile",
      "Third Quartile",
      "Highest Value",
      "Consensus Ex Max",
      "Consensus Ex Min",
      "Consensus Ex Max, Ex Min",
    ];

    this.dataService.changeDataPoint(dataPointObj, `|${period}`);

    if (this.dataSettings.view_by[0] === "yoy") {
      return;
    }

    if (blockFormulaBar.includes(dataPointObj.name)) {
      return;
    }

    if (
      (dataPointObj.period[`${period}`]["value"] === "-" ||
        dataPointObj.period[`${period}`]["value"] === null ||
        dataPointObj.period[`${period}`]["value"] === undefined) &&
      !isPOS
    ) {
      return;
    }

    if (
      dataPointObj.name === "High" &&
      this.apiResponce &&
      this.apiResponce["maxsource"]["period"][period]["value"] === null &&
      !isPOS
    ) {
      return;
    }

    if (
      dataPointObj.name === "Low" &&
      this.apiResponce &&
      this.apiResponce["minsource"]["period"][period]["value"] === null &&
      !isPOS
    ) {
      return;
    }

    this.selectedRow = dataPointObj.id;
    this.selectedCell = `${dataPointObj.id.toString()}|${period}`;
    // fetch data for param call
    let asOfDate = new Date();
    if (this.dataSettings.view_by[0] === "revision") {
      const revDate = this.dataSettings.revision;
      if (revDate === "1m") {
        asOfDate.setMonth(asOfDate.getMonth() - 1);
      } else if (revDate === "3m") {
        asOfDate.setMonth(asOfDate.getMonth() - 3);
      } else {
        const _dateStr = this.dataSettings.revision.split("|")[1];
        asOfDate = new Date(Date.parse(_dateStr));
      }
    }
    const mm = asOfDate.getMonth() + 1;
    const dd = asOfDate.getDate();
    const yyyy = asOfDate.getFullYear();
    const ticker = this.dataCall["meta"]["ticker"];
    let brokerId = 0;
    if (dataPointObj.name === "High" && !isPOS) {
      brokerId = this.dataCall["maxsource"]["period"][period]["value"];
      dpParams = {
        dp: `${this.dataCall[brokerId]["rid"][period]}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
        cut: "NMV",
        ticker: ticker,
        source: this.dataCall[brokerId].meta.short_name,
        growthType: encodeURI(
          this.dataSettings.view_by[0] === "yoy" ? "YoY%" : "Analytics",
        ),
        shouldLog: true,
        revision: this.dataSettings.revision,
        period: period,
        dapparameterId: this.dataCall["meta"]["dpid"],
        extras: `${this.dataCall[brokerId]["rid"][period]}|${period}`, //"16151916582|CY-2020"
      };
    } else if (dataPointObj.name === "Low" && !isPOS) {
      brokerId = this.dataCall["minsource"]["period"][period]["value"];
      dpParams = {
        dp: `${this.dataCall[brokerId]["rid"][period]}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
        cut: "NMV",
        ticker: ticker,
        source: this.dataCall[brokerId].meta.short_name,
        growthType: encodeURI(
          this.dataSettings.view_by[0] === "yoy" ? "YoY%" : "Analytics",
        ),
        shouldLog: true,
        revision: this.dataSettings.revision,
        period: period,
        dapparameterId: this.dataCall["meta"]["dpid"],
        extras: `${this.dataCall[brokerId]["rid"][period]}|${period}`, //"16151916582|CY-2020"
      };
    } else if (isPOS) {
      if (
        "pos_rid" in dataPointObj["meta"] &&
        "pos_dpid" in dataPointObj["meta"] &&
        dataPointObj["meta"]["pos_rid"] !== null &&
        dataPointObj["meta"]["pos_dpid"] !== null
      ) {
        brokerId = Number(dataPointObj.src);
        dpParams = {
          dp: `${dataPointObj["meta"]["pos_rid"]}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
          cut: "NMV",
          ticker: ticker,
          source: this.dataCall[brokerId].meta.short_name,
          growthType: encodeURI(
            this.dataSettings.view_by[0] === "yoy" ? "YoY%" : "Analytics",
          ),
          shouldLog: true,
          revision: this.dataSettings.revision,
          period: period,
          dapparameterId: dataPointObj["meta"]["pos_dpid"],
          extras: `${dataPointObj["meta"]["pos_rid"]}|${period}`, //"16151916582|CY-2020"
        };
      } else {
        return;
      }
    } else {
      dpParams = {
        dp: `${dataPointObj.rid[period]}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
        cut: "NMV",
        ticker: ticker,
        source: "consensus",
        growthType: encodeURI(
          this.dataSettings.view_by[0] === "yoy" ? "YoY%" : "Analytics",
        ),
        shouldLog: true,
        revision: this.dataSettings.revision,
        period: period,
        dapparameterId: this.dataCall["meta"]["dpid"],
        extras: `${dataPointObj.rid[period]}|${period}`, //"16151916582|CY-2020"
      };
    }
    // if(this.dataSettings.view_by[0] === "revision") {
    //   const dateDiff = this.appService.getFormattedDateDifference(asOfDate);
    //   dpParams["extras"] = `${dpParams["extras"]}-${dateDiff}${dpParams["consensus"]}`;
    // }
    if (this.tableName === "Broker") {
      dpParams["source"] = dataPointObj.meta.short_name;
    } else if (this.dataCall["meta"]["isforcast"][period] === false) {
      dpParams["source"] = "va actuals";
    } else if (dataPointObj.name === "High" || dataPointObj.name === "Low") {
      dpParams["source"] = this.dataCall[brokerId].meta.short_name;
    } else {
      dpParams["source"] = "consensus";
    }

    // if (dpParams.growthType === "YoY%") {
    //   dpParams["historical_focus"] = "VA Actuals";
    // }

    if (this.dataSettings.currency !== "Base") {
      dpParams["currency"] = this.dataSettings.currency;
    }
    this.store.dispatch(new SetDpParams(dpParams));
  }

  onDataResolved(resp) {
    if (!resp) {
      return;
    }
    this.apiResponce = resp;
    this.forecastPeriodData = resp["meta"]["isforcast"];
    let keys = [];
    if (this.showSortedIds) {
      keys = [...keys, ...resp.sorted_ids];
    }
    keys = [...keys, ...this.selectedKeys];
    let index = 0;
    const rows = [];
    const reaffirmAllSourcesObj = {};
    if (this.reaffirmCall)
      this.reaffirmCall["brokers"].forEach((reaffirmObj) => {
        if (reaffirmObj.reaffirm) {
          reaffirmAllSourcesObj[reaffirmObj.id] = { ...reaffirmObj };
        }
      });

    keys.forEach((keyName) => {
      const mainRow = resp[keyName];
      let newRow = {};
      let valKey = "";
      if (
        ["standarddeviation", "cv", "range", "brokercount"].includes(keyName)
      ) {
        valKey = "value";
      } else {
        if (this.dataSettings.view_by[0] === "yoy") {
          valKey = "yoy";
        } else {
          valKey = "value";
        }
      }
      newRow = this.formatRow(mainRow, valKey, keyName);
      // if (keyName === "brokercount") {
      //   newRow = mainRow;
      //   newRow["period"]["formatted"] = ""
      // } else {

      // }
      newRow["valKey"] = valKey;
      if (mainRow.meta && mainRow.meta.short_name) {
        newRow["name"] = mainRow.meta.short_name;
      } else if (this.keyColumnMapping[keyName]) {
        newRow["name"] = this.keyColumnMapping[keyName];
      } else {
        newRow["name"] = "-";
      }
      if (mainRow.meta && mainRow.meta.model_date) {
        newRow["date_published"] = new DatePipe("en-US").transform(
          mainRow.meta.model_date,
          "dd-MMM-yy",
        );
        newRow["date_published_raw"] = new Date(newRow["date_published"]);
        //TODO: test this
        const currentDate = dayjs(Date.parse(mainRow.meta.model_date));
        const diffInDays = Number(currentDate.diff(new Date(), "day"));
        // differenceInCalendarDays(
        //   Date.parse(mainRow.meta.model_date),
        //   Date.now(),
        // );
        if (diffInDays !== null && diffInDays !== undefined) {
          newRow["date_published"] = `${newRow["date_published"]} (${
            diffInDays === 0 ? "-" : ""
          }${diffInDays}d)`;
        }
        // newRow["date_published"] = Date.parse(mainRow.meta.model_date)
      }

      if (mainRow.meta && mainRow.meta.pos) {
        newRow["pos"] = formatCell(mainRow.meta.pos, "", "%", "");
      } else {
        newRow["pos"] = "-";
      }

      if (mainRow.meta) {
        if (keyName === "cv") {
          newRow["unit"] = "";
        } else {
          if (this.dataSettings.view_by[0] === "yoy") {
            if (
              !["standarddeviation", "cv", "range", "brokercount"].includes(
                keyName,
              )
            ) {
              newRow["unit"] = "";
            } else {
              newRow["unit"] = mainRow.meta.currency + mainRow.meta.magnitude;
            }
          } else {
            newRow["unit"] = mainRow.meta.currency + mainRow.meta.magnitude;
          }
        }
      }
      if (reaffirmAllSourcesObj[keyName]) {
        newRow["reaffirmTrue"] = true;
        newRow["reaffirm"] = reaffirmAllSourcesObj[keyName];
        newRow["reaffirmType"] = reaffirmAllSourcesObj[keyName]["reaffirmType"];
        newRow["reaffirmDate"] =
          reaffirmAllSourcesObj[keyName]["effectivestart"];
      } else {
        newRow["reaffirmTrue"] = false;
      }
      // if(mainRow.period)
      newRow["id"] = `${index}`;
      index++;
      newRow["src"] = keyName;
      rows.push(newRow);
    });
    for (const index in rows) {
      if (!("isResearchIconShow" in rows[index])) {
        rows[index]["isResearchIconShow"] = false;
      }
    }
    this.dataSource = rows;
    this.dataSourceDefaultOrder = [...rows];
    this.onDataSourceChanged.emit(this.dataSource.length);
    this.addResearchParameters();
  }

  ngOnDestroy() {
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
  }

  setHighLowDataPoint(src, period) {
    if (this.tableName === "Broker") {
      if ("maxsource" in this.apiResponce) {
        if (
          !isNaN(src) &&
          this.apiResponce["maxsource"]["period"][period] === Number(src)
        ) {
          return "#C5FFC5";
        }
      }
      if ("minsource" in this.apiResponce) {
        if (
          !isNaN(src) &&
          this.apiResponce["minsource"]["period"][period] === Number(src)
        ) {
          return "#FFD0D0";
        }
      }
    }
    return "";
  }

  sortData(colKey, sortDirection = "") {
    if (this.tableName === "Broker") {
      if (sortDirection) {
        this.sortDirection = sortDirection;
      } else {
        if (colKey === this.activeSort) {
          this.sortDirection =
            this.sortDirection === ""
              ? "asc"
              : this.sortDirection === "asc"
                ? "desc"
                : "";
        } else {
          this.sortDirection = "asc";
        }
      }
      this.activeSort = colKey;
      switch (colKey) {
        case "broker":
          this.stringSort("name", false);
          this.table.renderRows();
          break;
        case "date_published":
          this.dateSort("date_published_raw", false);
          this.table.renderRows();
          break;
        default:
          this.numberSort(colKey, false, true);
          this.table.renderRows();
      }
    }
  }

  stringSort(colName, isRaw) {
    let colKey = colName;
    if (isRaw) {
      colKey = `${colName}_raw`;
    }
    if (this.sortDirection === "") {
      this.dataSource = [...this.dataSourceDefaultOrder];
      this.activeSort = "";
    } else {
      this.dataSource.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[colKey].localeCompare(b[colKey]);
        }
        return b[colKey].localeCompare(a[colKey]);
      });
    }
  }

  numberSort(colName, isRaw, isPeriod) {
    let colKey = colName;
    if (isRaw) {
      colKey = `${colName}_raw`;
    }
    if (this.sortDirection === "") {
      this.dataSource = [...this.dataSourceDefaultOrder];
      this.activeSort = "";
    } else {
      this.dataSource.sort((a, b) => {
        if (this.sortDirection === "asc") {
          if (isPeriod) {
            const fisrtValue = a["period"][colKey]["raw"];
            const secondValue = b["period"][colKey]["raw"];
            return (
              (fisrtValue !== null ? fisrtValue : -Infinity) -
              (secondValue !== null ? secondValue : -Infinity)
            );
          }
          const fisrtValue = a[colKey];
          const secondValue = b[colKey];
          return (
            (fisrtValue !== null ? fisrtValue : -Infinity) -
            (secondValue !== null ? secondValue : -Infinity)
          );
        }
        if (isPeriod) {
          const fisrtValue = b["period"][colKey]["raw"];
          const secondValue = a["period"][colKey]["raw"];
          return (
            (fisrtValue !== null ? fisrtValue : -Infinity) -
            (secondValue !== null ? secondValue : -Infinity)
          );
        }
        const fisrtValue = b[colKey];
        const secondValue = a[colKey];
        return (
          (fisrtValue !== null ? fisrtValue : -Infinity) -
          (secondValue !== null ? secondValue : -Infinity)
        );
      });
    }
  }

  dateSort(colName, isRaw) {
    let colKey = colName;
    if (isRaw) {
      colKey = `${colName}_raw`;
    }
    if (this.sortDirection === "") {
      this.dataSource = [...this.dataSourceDefaultOrder];
      this.activeSort = "";
    } else {
      this.dataSource.sort((a, b) => {
        if (this.sortDirection === "asc") {
          const fisrtValue =
            a[colKey] !== null ? a[colKey] : new Date("01-01-1900");
          const secondValue =
            b[colKey] !== null ? b[colKey] : new Date("01-01-1900");
          return fisrtValue - secondValue;
        }
        const fisrtValue =
          b[colKey] !== null ? b[colKey] : new Date("01-01-1900");
        const secondValue =
          a[colKey] !== null ? a[colKey] : new Date("01-01-1900");
        return fisrtValue - secondValue;
      });
    }
  }

  addResearchParameters() {
    if (this.drugResearchParameters.length > 0) {
      this.showResearchParameterOnGrid.emit(this.dataSource);
    }
  }

  getDSMDOcumentDetails() {
    const selectedParameter = this.drugResearchParameters.find(
      (x) => x.parameterid === this.drug_dapparameterid,
    );
    const dapParamObj = {
      parameterid: selectedParameter["parameterid"],
      drugid: this.cTagId,
    };
    dapParamObj["brokers"] = selectedParameter.documents.map((x) => x.orgid);
    this.onResearchIconClick.emit(dapParamObj);
  }

  getDSMDOcumentDetailsByBroker(brokerId) {
    const selectedParameter = this.drugResearchParameters.find(
      (x) => x.parameterid === this.drug_dapparameterid,
    );
    const dapParamObj = {
      parameterid: selectedParameter["parameterid"],
      drugid: this.cTagId,
    };
    dapParamObj["brokers"] = [Number(brokerId)];
    this.onResearchIconClick.emit(dapParamObj);
  }
}
